import { render, staticRenderFns } from "./tooltip.vue?vue&type=template&id=a85e61ac"
import script from "./tooltip.vue?vue&type=script&lang=js"
export * from "./tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports